const size = 'size';
export const aliasSize = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    maxWidth: size,
    maxHeight: size,
    minTileWidth: size
};

//# sourceMappingURL=aliasSize.js.map